module.exports = __webpack_public_path__ + "img/detail-highlight-icon.727aa07e.svg";